import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ProjectNumberCard } from '../components/site/ProjectNumberCard';
import { SectionHeader } from '../components/site/SectionHeader';
import { SEOHead } from '../components/site/SEOHead';
import api from '../lib/api';

const categoryMap = {
  'devam-eden': { key: 'ongoing', title: 'Devam Eden Projeler', subtitle: 'Şu an devam eden projelerimiz' },
  'tamamlanan': { key: 'completed', title: 'Tamamlanan Projeler', subtitle: 'Başarıyla tamamlanan projelerimiz' },
  'gelecek': { key: 'future', title: 'Gelecek Projeler', subtitle: 'Yakın zamanda başlanacak projelerimiz' }
};

export default function Projects() {
  const { category } = useParams();
  const [projects, setProjects] = useState([]);
  const [seo, setSeo] = useState({});
  const [loading, setLoading] = useState(true);

  const catInfo = categoryMap[category] || categoryMap['devam-eden'];

  useEffect(() => {
    setLoading(true);
    Promise.all([
      api.get(`/projects?category=${catInfo.key}`),
      api.get('/seo/projects')
    ]).then(([p, s]) => {
      setProjects(p.data);
      setSeo(s.data);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [category, catInfo.key]);

  return (
    <div data-testid="projects-page">
      <SEOHead title={`${catInfo.title} - ${seo.title || ''}`} description={seo.description} keywords={seo.keywords} />
      
      {/* Hero Banner */}
      <div className="relative py-16 md:py-24 bg-[#0f1419]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            {catInfo.title}
          </h1>
          <p className="text-gray-300 mt-2">{catInfo.subtitle}</p>
          <div className="mt-4 w-16 h-1 rounded-full bg-[hsl(var(--gold))]" />
        </div>
      </div>

      {/* Category Tabs */}
      <div className="border-b border-border">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex gap-1 -mb-px">
            {Object.entries(categoryMap).map(([slug, info]) => (
              <Link
                key={slug}
                to={`/projeler/${slug}`}
                className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors duration-200 ${
                  category === slug
                    ? 'border-[hsl(var(--gold))] text-[hsl(var(--gold))]'
                    : 'border-transparent text-muted-foreground hover:text-foreground'
                }`}
                data-testid={`projects-tab-${slug}`}
              >
                {info.title}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Projects Grid */}
      <section className="py-14 md:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          {loading ? (
            <div className="flex justify-center py-20">
              <div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" />
            </div>
          ) : projects.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-muted-foreground">Bu kategoride henüz proje bulunmamaktadır.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {projects.map((project, i) => (
                <ProjectNumberCard key={project.id} project={project} index={i} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
